module.exports = __webpack_public_path__ + "img/zhendang.d79e4416.svg";